let debounceTimer;
export default function debounce(func, delay) {
    return function () {
        let context = this;
        let args = arguments;
        debounceTimer && clearTimeout(debounceTimer);
        debounceTimer = global.setTimeout(() => {
            func.apply(context, args);
        }, delay);
        return debounceTimer;
    };
}
